import { render } from "./BaseDisabledRadio.vue?vue&type=template&id=55cd959c&scoped=true"
import script from "./BaseDisabledRadio.vue?vue&type=script&lang=js"
export * from "./BaseDisabledRadio.vue?vue&type=script&lang=js"

import "./BaseDisabledRadio.vue?vue&type=style&index=0&id=55cd959c&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cd959c"]])

export default __exports__